import './App.css';
import {useContext} from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";
import Home from './components/Home/Home'
import About from './components/About/About'
import Projects from './components/Projects/Projects'
import PersonalProjects from './components/SideProject/SideProject'
import Skills from './components/Skills/Skills'
import Contact from './components/Contact/Contact'
import Navbar from './components/Navbar/Navbar'
import GoHome from './components/GoHome/GoHome'
import { NetworkContext } from './NetworkContext';
import OfflinePage from './components/Offline/OfflinePage';
import { EdgeAura } from "edge-aura/react";


const getAuraPalette = (pathname) => {
  switch (pathname) {
    case '/about':
      return 'sakura';
    case '/skills':
      return 'ocean';
    case '/projects':
      return 'aurora';
    case '/personal-projects':
      return 'sunset';
    case '/contact':
      return 'ember';
    default:
      return 'opal';
  }
};

function AppContent() {
  const location = useLocation();
  const palette = getAuraPalette(location.pathname);

  return (
    <>
      <EdgeAura 
      options={{
        geometry: { cornerFill: true },
        palette: { background: "dark", blendMode: "plus-lighter" },
      }}
      palette={palette} />
      <div className="ambient-glow-center"></div>
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/skills' element={<Skills />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/personal-projects' element={<PersonalProjects />} />
        <Route path='/contact' element={<Contact />} />
      </Routes>
      <GoHome />
    </>
  );
}

function App() {
  const { isOnline } = useContext(NetworkContext);

  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
